// import React from "react";
// import { useFormik } from "formik";
// import { useMutation } from "react-query";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import { Button, TextField, MenuItem } from "@mui/material";
// import { postPagesD } from "../../../Services/PageDesign";

// const AddPageDesign = () => {
//   const navigate = useNavigate();

//   const { mutate: createPageDesign, isLoading } = useMutation(postPagesD, {
//     onSuccess: (response) => {
//       toast.success(
//         response?.data?.message || "Page Design Created Successfully",
//       );

//       navigate("/page-design-setup");
//     },

//     onError: (error) => {
//       toast.error(
//         error?.response?.data?.message || "Failed to create Page Design",
//       );
//     },
//   });

//   const formik = useFormik({
//     initialValues: {
//       page_type_name: "",

//       page_format: {
//         unit: "inch",
//         width: "",
//         height: "",
//         orientation: "portrait",
//       },

//       category: [],
//       sub_category: [],
//       brand: [],
//     },

//     onSubmit: (values) => {
//       const payload = {
//         page_type_name: values.page_type_name,

//         page_format: {
//           unit: values.page_format.unit,
//           width: Number(values.page_format.width),
//           height: Number(values.page_format.height),
//           orientation: values.page_format.orientation,
//         },

//         category: values.category,
//         sub_category: values.sub_category,
//         brand: values.brand,
//       };

//       createPageDesign(payload);
//     },
//   });

//   return (
//     <div className="p-5">
//       {/* Header */}
//       <div className="mb-6">
//         <h1 className="text-2xl font-semibold text-gray-800">
//           Add Page Design
//         </h1>

//         <p className="mt-1 text-sm text-gray-500">Create a new page design</p>
//       </div>

//       {/* Form */}
//       <form
//         onSubmit={formik.handleSubmit}
//         className="rounded-lg bg-white p-6 shadow"
//       >
//         <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
//           {/* Page Type Name */}
//           <TextField
//             fullWidth
//             label="Page Type Name"
//             name="page_type_name"
//             value={formik.values.page_type_name}
//             onChange={formik.handleChange}
//             onBlur={formik.handleBlur}
//             error={
//               formik.touched.page_type_name &&
//               Boolean(formik.errors.page_type_name)
//             }
//             helperText={
//               formik.touched.page_type_name && formik.errors.page_type_name
//             }
//           />

//           {/* Unit */}
//           <TextField
//             select
//             fullWidth
//             label="Unit"
//             name="page_format.unit"
//             value={formik.values.page_format.unit}
//             onChange={formik.handleChange}
//           >
//             <MenuItem value="inch">Inch</MenuItem>
//             <MenuItem value="cm">CM</MenuItem>
//             <MenuItem value="mm">MM</MenuItem>
//           </TextField>

//           {/* Width */}
//           <TextField
//             fullWidth
//             type="number"
//             label="Width"
//             name="page_format.width"
//             value={formik.values.page_format.width}
//             onChange={formik.handleChange}
//             inputProps={{
//               min: 0,
//               step: "0.01",
//             }}
//           />

//           {/* Height */}
//           <TextField
//             fullWidth
//             type="number"
//             label="Height"
//             name="page_format.height"
//             value={formik.values.page_format.height}
//             onChange={formik.handleChange}
//             inputProps={{
//               min: 0,
//               step: "0.01",
//             }}
//           />

//           {/* Orientation */}
//           <TextField
//             select
//             fullWidth
//             label="Orientation"
//             name="page_format.orientation"
//             value={formik.values.page_format.orientation}
//             onChange={formik.handleChange}
//           >
//             <MenuItem value="portrait">Portrait</MenuItem>

//             <MenuItem value="landscape">Landscape</MenuItem>
//           </TextField>

//           {/* Category */}
//           <TextField
//             fullWidth
//             label="Category"
//             placeholder="Category IDs: 1,2,3"
//             name="category"
//             value={formik.values.category.join(",")}
//             onChange={(e) => {
//               const value = e.target.value
//                 .split(",")
//                 .map((id) => id.trim())
//                 .filter(Boolean)
//                 .map(Number);

//               formik.setFieldValue("category", value);
//             }}
//           />

//           {/* Sub Category */}
//           <TextField
//             fullWidth
//             label="Sub Category"
//             placeholder="Sub Category IDs: 101,102"
//             name="sub_category"
//             value={formik.values.sub_category.join(",")}
//             onChange={(e) => {
//               const value = e.target.value
//                 .split(",")
//                 .map((id) => id.trim())
//                 .filter(Boolean)
//                 .map(Number);

//               formik.setFieldValue("sub_category", value);
//             }}
//           />

//           {/* Brand */}
//           <TextField
//             fullWidth
//             label="Brand"
//             placeholder="Brand IDs: 1,2"
//             name="brand"
//             value={formik.values.brand.join(",")}
//             onChange={(e) => {
//               const value = e.target.value
//                 .split(",")
//                 .map((id) => id.trim())
//                 .filter(Boolean)
//                 .map(Number);

//               formik.setFieldValue("brand", value);
//             }}
//           />
//         </div>

//         {/* Buttons */}
//         <div className="mt-7 flex justify-end gap-3 border-t pt-5">
//           <Button
//             type="button"
//             variant="outlined"
//             onClick={() => navigate("/page-design-setup")}
//           >
//             Cancel
//           </Button>

//           <Button type="submit" variant="contained" disabled={isLoading}>
//             {isLoading ? "Saving..." : "Save"}
//           </Button>
//         </div>
//       </form>
//     </div>
//   );
// };
// export default AddPageDesign;

// import React from "react";
// import { useFormik } from "formik";
// import { useMutation } from "react-query";
// import { toast } from "react-toastify";
// import { useNavigate, useLocation, useParams } from "react-router-dom";
// import { Button, TextField, MenuItem } from "@mui/material";
// import { patchPagesD, postPagesD } from "../../../Services/PageDesign";

// // import {
// //   postPagesD,
// //   patchPagesD,
// // } from "../../../Services/PageDesign";

// const AddPageDesign = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { type } = useParams();

//   // Edit ke time PageDesignSetup se data yahan milega
//   const editData = location.state?.pageData;

//   // /page-design-setup/add = Add
//   // /page-design-setup/3 = Edit
//   const isEdit = type !== undefined && type !== "add";

//   // =========================
//   // POST
//   // =========================

//   const { mutate: createPageDesign, isLoading: isCreating } = useMutation(
//     postPagesD,
//     {
//       onSuccess: (response) => {
//         toast.success(
//           response?.data?.message || "Page Design Created Successfully",
//         );

//         navigate("/page-design-setup");
//       },

//       onError: (error) => {
//         toast.error(
//           error?.response?.data?.message || "Failed to create Page Design",
//         );
//       },
//     },
//   );

//   // =========================
//   // PATCH
//   // =========================

//   const { mutate: updatePageDesign, isLoading: isUpdating } = useMutation(
//     patchPagesD,
//     {
//       onSuccess: (response) => {
//         toast.success(
//           response?.data?.message || "Page Design Updated Successfully",
//         );

//         navigate("/page-design-setup");
//       },

//       onError: (error) => {
//         toast.error(
//           error?.response?.data?.message || "Failed to update Page Design",
//         );
//       },
//     },
//   );

//   const formik = useFormik({
//     enableReinitialize: true,

//     initialValues: {
//       page_type_name: editData?.page_type_name || "",

//       page_format: {
//         unit: editData?.page_format?.unit || "inch",

//         width: editData?.page_format?.width || "",

//         height: editData?.page_format?.height || "",

//         orientation: editData?.page_format?.orientation || "portrait",
//       },

//       category: editData?.category?.map((item) => item.id) || [],

//       sub_category: editData?.sub_category?.map((item) => item.id) || [],

//       brand: editData?.brand?.map((item) => item.id) || [],
//     },

//     onSubmit: (values) => {
//       // =========================
//       // ADD
//       // =========================

//       if (!isEdit) {
//         const payload = {
//           page_type_name: values.page_type_name,

//           page_format: {
//             unit: values.page_format.unit,

//             width: Number(values.page_format.width),

//             height: Number(values.page_format.height),

//             orientation: values.page_format.orientation,
//           },

//           category: values.category,

//           sub_category: values.sub_category,

//           brand: values.brand,
//         };

//         createPageDesign(payload);

//         return;
//       }

//       // =========================
//       // EDIT / PATCH
//       // =========================

//       const payload = {
//         page_format_id: Number(type),

//         page_type_name: values.page_type_name,

//         page_format: {
//           unit: values.page_format.unit,

//           width: Number(values.page_format.width),

//           height: Number(values.page_format.height),

//           orientation: values.page_format.orientation,
//         },

//         category: values.category,

//         sub_category: values.sub_category,

//         brand: values.brand,
//       };

//       updatePageDesign(payload);
//     },
//   });

//   const isLoading = isCreating || isUpdating;

//   return (
//     <div className="p-5">
//       {/* Header */}

//       <div className="mb-6">
//         <h1 className="text-2xl font-semibold text-gray-800">
//           {isEdit ? "Update Page Design" : "Add Page Design"}
//         </h1>

//         <p className="mt-1 text-sm text-gray-500">
//           {isEdit ? "Update page design details" : "Create a new page design"}
//         </p>
//       </div>

//       {/* Form */}

//       <form
//         onSubmit={formik.handleSubmit}
//         className="rounded-lg bg-white p-6 shadow"
//       >
//         <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
//           {/* Page Type Name */}

//           <TextField
//             fullWidth
//             label="Page Type Name"
//             name="page_type_name"
//             value={formik.values.page_type_name}
//             onChange={formik.handleChange}
//             onBlur={formik.handleBlur}
//           />

//           {/* Unit */}

//           <TextField
//             select
//             fullWidth
//             label="Unit"
//             name="page_format.unit"
//             value={formik.values.page_format.unit}
//             onChange={formik.handleChange}
//           >
//             <MenuItem value="inch">Inch</MenuItem>

//             <MenuItem value="cm">CM</MenuItem>

//             <MenuItem value="mm">MM</MenuItem>
//           </TextField>

//           {/* Width */}

//           <TextField
//             fullWidth
//             type="number"
//             label="Width"
//             name="page_format.width"
//             value={formik.values.page_format.width}
//             onChange={formik.handleChange}
//             inputProps={{
//               min: 0,
//               step: "0.01",
//             }}
//           />

//           {/* Height */}

//           <TextField
//             fullWidth
//             type="number"
//             label="Height"
//             name="page_format.height"
//             value={formik.values.page_format.height}
//             onChange={formik.handleChange}
//             inputProps={{
//               min: 0,
//               step: "0.01",
//             }}
//           />

//           {/* Orientation */}

//           <TextField
//             select
//             fullWidth
//             label="Orientation"
//             name="page_format.orientation"
//             value={formik.values.page_format.orientation}
//             onChange={formik.handleChange}
//           >
//             <MenuItem value="portrait">Portrait</MenuItem>

//             <MenuItem value="landscape">Landscape</MenuItem>
//           </TextField>

//           {/* Category */}

//           <TextField
//             fullWidth
//             label="Category"
//             placeholder="Category IDs: 1,2,3"
//             value={formik.values.category.join(",")}
//             onChange={(e) => {
//               const value = e.target.value
//                 .split(",")
//                 .map((id) => id.trim())
//                 .filter(Boolean)
//                 .map(Number);

//               formik.setFieldValue("category", value);
//             }}
//           />

//           {/* Sub Category */}

//           <TextField
//             fullWidth
//             label="Sub Category"
//             placeholder="Sub Category IDs: 101,102"
//             value={formik.values.sub_category.join(",")}
//             onChange={(e) => {
//               const value = e.target.value
//                 .split(",")
//                 .map((id) => id.trim())
//                 .filter(Boolean)
//                 .map(Number);

//               formik.setFieldValue("sub_category", value);
//             }}
//           />

//           {/* Brand */}

//           <TextField
//             fullWidth
//             label="Brand"
//             placeholder="Brand IDs: 1,2"
//             value={formik.values.brand.join(",")}
//             onChange={(e) => {
//               const value = e.target.value
//                 .split(",")
//                 .map((id) => id.trim())
//                 .filter(Boolean)
//                 .map(Number);

//               formik.setFieldValue("brand", value);
//             }}
//           />
//         </div>

//         {/* Buttons */}

//         <div className="mt-7 flex justify-end gap-3 border-t pt-5">
//           <Button
//             type="button"
//             variant="outlined"
//             onClick={() => navigate("/page-design-setup")}
//           >
//             Cancel
//           </Button>

//           <Button type="submit" variant="contained" disabled={isLoading}>
//             {isLoading ? "Saving..." : isEdit ? "Update" : "Save"}
//           </Button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default AddPageDesign;

import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
// import Select from "react-select";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { patchPagesD, postPagesD } from "../../../Services/PageDesign";
import { getSubMenu } from "../../../Services/SubMenu";
import { getSubSubMenu } from "../../../Services/SubSubManu";

// STATIC CATEGORY / SUB CATEGORY / BRAND DATA

const STATIC_CATEGORIES = [
  { id: 1, title: "Electronics" },
  { id: 2, title: "Fashion" },
  { id: 3, title: "Grocery" },
  { id: 4, title: "Furniture" },
  { id: 5, title: "Sports" },
];

const STATIC_SUB_CATEGORIES = [
  { id: 101, title: "Mobiles" },
  { id: 102, title: "Laptops" },
  { id: 103, title: "Men Clothing" },
  { id: 104, title: "Women Clothing" },
  { id: 105, title: "Shoes" },
];

const STATIC_BRANDS = [
  { id: 201, title: "Samsung" },
  { id: 202, title: "Apple" },
  { id: 203, title: "Nike" },
  { id: 204, title: "Adidas" },
  { id: 205, title: "Sony" },
];

// MAIN COMPONENT

export default function AddDynamicUI() {
  const navigate = useNavigate();
  const { type } = useParams();
  const { state } = useLocation();
  const [subMenus, setSubMenus] = useState([]);
  const [subMenuSearch, setSubMenuSearch] = useState("");
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(null);
  // STATES

  const [pageName, setPageName] = useState("");

  const [selection, setSelection] = useState("");

  const [data, setData] = useState({
    pagetypename: {},
  });

  const [order, setOrder] = useState([]);

  const [categories, setCategories] = useState([]);

  const [subCategories, setSubCategories] = useState([]);

  const [brands, setBrands] = useState([]);
  const [pageNames, setPageNames] = useState([]);

  // sub sub manu
  const [subSubMenuSearch, setSubSubMenuSearch] = useState("");
  const [showSubSubMenu, setShowSubSubMenu] = useState(false);
  const [selectedSubSubMenu, setSelectedSubSubMenu] = useState(null);

  const [subSubMenus, setSubSubMenus] = useState([]);

  const { isLoading: isSubSubMenuLoading } = useQuery(
    ["subSubMenu"],
    getSubSubMenu,
    {
      onSuccess: (response) => {
        const list = response?.data?.data || [];

        setSubSubMenus(list);
      },

      onError: (error) => {
        toast.error(error?.response?.data?.message);
      },
    },
  );

  const filteredSubSubMenus = subSubMenus.filter((item) =>
    item?.name?.toLowerCase().includes(subSubMenuSearch.toLowerCase()),
  );
  // EDIT MODE

  const isEdit = type !== undefined && type !== "add";

  // LOAD EDIT DATA

  // useEffect(() => {
  //   if (!state) return;

  //   // PAGE NAME / TYPE

  //   const pageType = state?.page_type_name || "";

  //   setPageName(pageType);

  //   if (pageType === "default") {
  //     setSelection("default");
  //   } else if (pageType === "home") {
  //     setSelection("home");
  //   } else {
  //     setSelection("other");
  //   }

  //   // PAGE FORMAT

  //   if (Array.isArray(state?.page_format)) {
  //     const formatObj = {};
  //     const formatOrder = [];

  //     state.page_format.forEach((item) => {
  //       if (!item?.key) return;

  //       formatObj[item.key] = item?.value ?? "";

  //       formatOrder.push(item.key);
  //     });

  //     setData({
  //       pagetypename: formatObj,
  //     });

  //     setOrder(formatOrder);
  //   }

  //   // CATEGORY

  //   if (Array.isArray(state?.category)) {
  //     setCategories(
  //       state.category.map((item) => ({
  //         title:
  //           item?.title ||
  //           STATIC_CATEGORIES.find(
  //             (x) => String(x.id) === String(item?.category_id),
  //           )?.title ||
  //           "",

  //         id: item?.category_id,
  //       })),
  //     );
  //   }

  //   // SUB CATEGORY

  //   if (Array.isArray(state?.sub_category)) {
  //     setSubCategories(
  //       state.sub_category.map((item) => ({
  //         title:
  //           item?.title ||
  //           STATIC_SUB_CATEGORIES.find(
  //             (x) => String(x.id) === String(item?.sub_category_id),
  //           )?.title ||
  //           "",

  //         id: item?.sub_category_id,
  //       })),
  //     );
  //   }

  //   // BRAND

  //   if (Array.isArray(state?.brand)) {
  //     setBrands(
  //       state.brand.map((item) => ({
  //         title:
  //           item?.title ||
  //           STATIC_BRANDS.find((x) => String(x.id) === String(item?.brand_id))
  //             ?.title ||
  //           "",

  //         id: item?.brand_id,
  //       })),
  //     );
  //   }
  // }, [state]);

  // useEffect(() => {
  //   const editData = state?.pageData || state;

  //   if (!editData) return;

  //   // PAGE TYPE / NAME
  //   const pageType = editData?.page_type_name || "";

  //   setPageName(pageType);

  //   if (pageType === "default") {
  //     setSelection("default");
  //   } else if (pageType === "home") {
  //     setSelection("home");
  //   } else {
  //     setSelection("other");
  //   }

  //   // PAGE FORMAT / SECTIONS
  //   const formatObj = {};
  //   const formatOrder = [];

  //   if (Array.isArray(editData?.page_format)) {
  //     editData.page_format.forEach((item) => {
  //       if (!item?.key) return;

  //       formatObj[item.key] = item?.value ?? "";
  //       formatOrder.push(item.key);
  //     });
  //   }

  //   setData({
  //     pagetypename: formatObj,
  //   });

  //   setOrder(formatOrder);

  //   // CATEGORY
  //   if (Array.isArray(editData?.category)) {
  //     setCategories(
  //       editData.category.map((item) => ({
  //         id: item?.category_id,
  //         title:
  //           item?.title ||
  //           STATIC_CATEGORIES.find(
  //             (x) => String(x.id) === String(item?.category_id),
  //           )?.title ||
  //           "",
  //       })),
  //     );
  //   } else {
  //     setCategories([]);
  //   }

  //   // SUB CATEGORY
  //   if (Array.isArray(editData?.sub_category)) {
  //     setSubCategories(
  //       editData.sub_category.map((item) => ({
  //         id: item?.sub_category_id,
  //         title:
  //           item?.title ||
  //           STATIC_SUB_CATEGORIES.find(
  //             (x) => String(x.id) === String(item?.sub_category_id),
  //           )?.title ||
  //           "",
  //       })),
  //     );
  //   } else {
  //     setSubCategories([]);
  //   }

  //   // BRAND
  //   if (Array.isArray(editData?.brand)) {
  //     setBrands(
  //       editData.brand.map((item) => ({
  //         id: item?.brand_id,
  //         title:
  //           item?.title ||
  //           STATIC_BRANDS.find((x) => String(x.id) === String(item?.brand_id))
  //             ?.title ||
  //           "",
  //       })),
  //     );
  //   } else {
  //     setBrands([]);
  //   }

  // }, [state]);

  useEffect(() => {
    const editData = state?.pageData || state;

    if (!editData) return;

    // PAGE TYPE
    const pageType = editData?.page_type_name || "";

    setPageName(pageType);

    if (pageType === "default") {
      setSelection("default");
    } else if (pageType === "home") {
      setSelection("home");
    } else {
      setSelection("other");
    }

    // PAGE FORMAT
    const formatObj = {};
    const formatOrder = [];

    if (Array.isArray(editData?.page_format)) {
      editData.page_format.forEach((item) => {
        if (!item?.key) return;

        formatObj[item.key] = item?.value ?? "";
        formatOrder.push(item.key);
      });
    }

    setData({
      pagetypename: formatObj,
    });

    setOrder(formatOrder);

    // SUB MENU - UPDATE DATA
    if (editData?.sub_menu && subMenus.length > 0) {
      const subMenu = subMenus.find(
        (item) => String(item.id) === String(editData.sub_menu),
      );

      if (subMenu) {
        setSelectedSubMenu(subMenu);
      }
    }

    // SUB SUB MENU - UPDATE DATA
    if (editData?.sub_sub_menu && subSubMenus.length > 0) {
      const subSubMenu = subSubMenus.find(
        (item) => String(item.id) === String(editData.sub_sub_menu),
      );

      if (subSubMenu) {
        setSelectedSubSubMenu(subSubMenu);
      }
    }

    // CATEGORY
    if (Array.isArray(editData?.category)) {
      setCategories(
        editData.category.map((item) => ({
          id: item?.category_id,
          title:
            item?.title ||
            STATIC_CATEGORIES.find(
              (x) => String(x.id) === String(item?.category_id),
            )?.title ||
            "",
        })),
      );
    } else {
      setCategories([]);
    }

    // SUB CATEGORY
    if (Array.isArray(editData?.sub_category)) {
      setSubCategories(
        editData.sub_category.map((item) => ({
          id: item?.sub_category_id,
          title:
            item?.title ||
            STATIC_SUB_CATEGORIES.find(
              (x) => String(x.id) === String(item?.sub_category_id),
            )?.title ||
            "",
        })),
      );
    } else {
      setSubCategories([]);
    }

    // BRAND
    if (Array.isArray(editData?.brand)) {
      setBrands(
        editData.brand.map((item) => ({
          id: item?.brand_id,
          title:
            item?.title ||
            STATIC_BRANDS.find((x) => String(x.id) === String(item?.brand_id))
              ?.title ||
            "",
        })),
      );
    } else {
      setBrands([]);
    }
  }, [state, subMenus, subSubMenus]);

  // POST API
  // SAME API AS AddPageDesign

  const { mutate: createPageDesign, isLoading: isCreating } = useMutation(
    postPagesD,
    {
      onSuccess: (response) => {
        if (response?.data?.response_code === 200) {
          toast.success(
            response?.data?.message || "Page Design Created Successfully",
          );

          resetForm();

          navigate("/page-design-setup");
        } else {
          toast.warning(
            response?.data?.message || "Failed to create Page Design",
          );
        }
      },

      onError: (error) => {
        console.error(error);

        toast.error(
          error?.response?.data?.message || "Failed to create Page Design",
        );
      },
    },
  );

  // PATCH API
  // SAME API AS AddPageDesign

  const { mutate: updatePageDesign, isLoading: isUpdating } = useMutation(
    patchPagesD,
    {
      onSuccess: (response) => {
        if (response?.data?.response_code === 200) {
          toast.success(
            response?.data?.message || "Page Design Updated Successfully",
          );

          resetForm();

          navigate("/page-design-setup");
        } else {
          toast.warning(
            response?.data?.message || "Failed to update Page Design",
          );
        }
      },

      onError: (error) => {
        console.error(error);

        toast.error(
          error?.response?.data?.message || "Failed to update Page Design",
        );
      },
    },
  );

  const isLoading = isCreating || isUpdating;

  // RESET

  // sub manu
  const { isLoading: isSubMenuLoading } = useQuery(["subMenu"], getSubMenu, {
    onSuccess: (response) => {
      console.log("SUB MENU API RESPONSE:", response);

      const menuList = response?.data?.data || [];

      setSubMenus(menuList);
    },

    onError: (error) => {
      console.error("SUB MENU API ERROR:", error);

      toast.error(error?.response?.data?.message || "Failed to load sub menu");
    },
  });

  const filteredSubMenus = subMenus.filter((item) =>
    item?.name?.toLowerCase().includes(subMenuSearch.toLowerCase()),
  );
  const resetForm = () => {
    setPageName("");

    setSelection("");

    setData({
      pagetypename: {},
    });

    setOrder([]);

    setCategories([]);

    setSubCategories([]);

    setBrands([]);
  };

  // ADD DYNAMIC SECTION

  const addSection = (sectionType) => {
    setData((prev) => {
      const existingKeys = Object.keys(prev.pagetypename).filter((key) =>
        key.startsWith(sectionType),
      );

      let newIndex = "";

      if (existingKeys.length > 0) {
        newIndex = existingKeys.length;
      }

      const newKey = `${sectionType}${newIndex}`;

      if (prev.pagetypename[newKey] !== undefined) {
        return prev;
      }

      setOrder((prevOrder) => [...prevOrder, newKey]);

      return {
        ...prev,

        pagetypename: {
          ...prev.pagetypename,

          [newKey]: "",
        },
      };
    });
  };

  // CHANGE SECTION VALUE

  const handleChange = (key, value) => {
    setData((prev) => ({
      ...prev,

      pagetypename: {
        ...prev.pagetypename,

        [key]: value,
      },
    }));
  };

  // REMOVE SECTION

  const handleRemove = (key) => {
    setData((prev) => {
      const updated = {
        ...prev.pagetypename,
      };

      delete updated[key];

      return {
        pagetypename: updated,
      };
    });

    setOrder((prevOrder) => prevOrder.filter((item) => item !== key));
  };

  // ADD CATEGORY / SUB CATEGORY / BRAND

  const handleAddItem = (listSetter, list, newItem) => {
    if (!newItem?.id || !newItem?.title) {
      return;
    }

    const alreadyExists = list.some(
      (item) => String(item.id) === String(newItem.id),
    );

    if (alreadyExists) {
      toast.warning("Item already added");

      return;
    }

    listSetter([
      ...list,

      {
        id: newItem.id,
        title: newItem.title,
      },
    ]);
  };

  // REMOVE CATEGORY / SUB CATEGORY / BRAND

  const handleRemoveItem = (listSetter, list, index) => {
    const updatedList = list.filter((_, i) => i !== index);

    listSetter(updatedList);
  };

  // PAGE TYPE

  const handleSelectionChange = (e) => {
    const value = e.target.value;

    setSelection(value);

    if (value === "default") {
      setPageName("default");
    } else if (value === "home") {
      setPageName("home");
    } else {
      setPageName("");
    }
  };

  // SUBMIT

  const handleSubmit = () => {
    // VALIDATION

    if (!pageName.trim()) {
      toast.warning("Please enter page name");

      return;
    }

    // PAGE FORMAT

    const pageFormat = order
      .filter((key) => {
        const value = data.pagetypename[key];

        return value !== "" && value !== undefined && value !== null;
      })
      .map((key) => ({
        key: key,

        value: data.pagetypename[key],
      }));

    // FINAL PAYLOAD
    // Dynamic Page UI

    const payload = {
      page_type_name: pageName,

      page_format: pageFormat,

      store_id: localStorage.getItem("store_id"),

      sub_menu: selectedSubMenu?.id || null,

      sub_sub_menu: selectedSubSubMenu?.id || null,

      category: categories.map((item) => ({
        title: item.title,

        category_id: Number(item.id),
      })),

      sub_category: subCategories.map((item) => ({
        title: item.title,

        sub_category_id: Number(item.id),
      })),

      brand: brands.map((item) => ({
        title: item.title,

        brand_id: Number(item.id),
      })),
    };

    console.log("PAGE DESIGN PAYLOAD:", payload);

    // POST

    if (!isEdit) {
      createPageDesign(payload);

      return;
    }

    // PATCH

    const updatePayload = {
      page_format_id: Number(type),

      ...payload,
    };

    console.log("PAGE DESIGN UPDATE PAYLOAD:", updatePayload);

    updatePageDesign(updatePayload);
  };

  // RENDER

  return (
    <div className="max-w-8xl mx-auto p- space-y-6">
      {/* HEADER */}
      <div>
        <h1 className="text-2xl font-semibold text-gray-800">
          {isEdit ? "Update Page Design" : "Add Page Design"}
        </h1>

        <p className="mt-1 text-sm text-gray-500">
          {isEdit ? "Update page design details" : "Create a new page design"}
        </p>
      </div>
      {/* PAGE TYPE */}
      <div className="space-y-2">
        <label className="block font-medium text-gray-700">
          Select Page Name Type
        </label>

        <select
          value={selection}
          onChange={handleSelectionChange}
          className="border border-gray-300 px-3 py-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select Page Type</option>

          <option value="home">Home</option>

          <option value="default">Default</option>

          <option value="other">Other</option>
        </select>
      </div>
      {/* PAGE NAME */}
      <div className="space-y-2">
        <label className="block font-medium text-gray-700">Page Name</label>

        <input
          type="text"
          value={pageName}
          onChange={(e) => setPageName(e.target.value)}
          placeholder="Enter page name"
          disabled={selection === "default" || selection === "home"}
          className="border border-gray-300 px-3 py-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* <div className="space-y-2">
          {" "}
          <label className="block font-medium text-gray-700">
            {" "}
            Sub Menu{" "}
          </label>{" "}
          <div className="relative">
            <input
              type="text"
              value={selectedSubMenu ? selectedSubMenu.name : subMenuSearch}
              onChange={(e) => {
                setSubMenuSearch(e.target.value);
                setSelectedSubMenu(null);
                setShowSubMenu(true);
              }}
              onFocus={() => setShowSubMenu(true)}
              placeholder={
                isSubMenuLoading ? "Loading Sub Menu..." : "Search Sub Menu..."
              }
              className="border border-gray-300 px-3 py-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
            />

            {showSubMenu && !isSubMenuLoading && (
              <div className="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                {filteredSubMenus.length > 0 ? (
                  filteredSubMenus.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => {
                        setSelectedSubMenu(item);
                        setSubMenuSearch("");
                        setShowSubMenu(false);
                      }}
                      className="px-3 py-2 cursor-pointer hover:bg-blue-50"
                    >
                      {item.name}
                    </div>
                  ))
                ) : (
                  <div className="px-3 py-2 text-gray-500">
                    No Sub Menu Found
                  </div>
                )}
              </div>
            )}
          </div>
        </div> */}
        {/* <div className="space-y-2">
          <label className="block font-medium text-gray-700">
            Sub Sub Menu
          </label>

          <div className="relative">
            <input
              type="text"
              value={
                selectedSubSubMenu ? selectedSubSubMenu.name : subSubMenuSearch
              }
              onChange={(e) => {
                setSubSubMenuSearch(e.target.value);
                setSelectedSubSubMenu(null);
                setShowSubSubMenu(true);
              }}
              onFocus={() => setShowSubSubMenu(true)}
              placeholder={
                isSubSubMenuLoading
                  ? "Loading Sub Sub Menu..."
                  : "Search Sub Sub Menu..."
              }
              className="border border-gray-300 px-3 py-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
            />

            {showSubSubMenu && !isSubSubMenuLoading && (
              <div className="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                {filteredSubSubMenus.length > 0 ? (
                  filteredSubSubMenus.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => {
                        setSelectedSubSubMenu(item);
                        setSubSubMenuSearch("");
                        setShowSubSubMenu(false);

                        console.log("Selected Sub Sub Menu:", item);
                      }}
                      className="px-3 py-2 cursor-pointer hover:bg-blue-50 text-gray-700"
                    >
                      {item.name}
                    </div>
                  ))
                ) : (
                  <div className="px-3 py-2 text-gray-500">
                    No Sub Sub Menu Found
                  </div>
                )}
              </div>
            )}
          </div>
        </div> */}
      </div>
      {/* ADD SECTION */}
      <div className="space-y-2">
        <label className="block font-medium text-gray-700">Add Section</label>

        <select
          defaultValue=""
          onChange={(e) => {
            const value = e.target.value;

            if (value) {
              addSection(value);
            }

            e.target.value = "";
          }}
          className="border border-gray-300 px-3 py-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select Section</option>

          {/* <option value="banner">Banner</option>

          <option value="product">Product</option>

          <option value="product_varient">Product Variant</option>

          <option value="video">Video</option> */}
          <option value="slider">Slider</option>

          <option value="customer_brand">Customer Brand</option>

          <option value="partner_brand">Partner Brand</option>

          <option value="case_study"> Case Study</option>
          <option value="blog">Blog</option>
          <option value="content">Content</option>
          <option value="faq">Faq</option>
          <option value="gallery_image">Gallery Image</option>
          <option value="gallery_video">Gallery video</option>
          <option value="event">Event</option>
          <option value="news">News</option>
        </select>
      </div>
      {/* DYNAMIC SECTIONS */}
      {order.length > 0 && (
        <div className="border-t pt-5 space-y-3">
          <h3 className="text-lg font-semibold text-gray-800">Page Sections</h3>

          {order.map((key) => (
            <div
              key={key}
              className="flex items-center gap-4 p-3 border rounded-lg bg-gray-50"
            >
              <label className="font-medium w-40 capitalize text-gray-700">
                {key.replace(/_/g, " ")}
              </label>

              <input
                type="number"
                value={data.pagetypename[key] ?? ""}
                onChange={(e) => handleChange(key, e.target.value)}
                placeholder={`Enter ${key} number`}
                className="border border-gray-300 px-3 py-2 rounded-lg w-44 sm:w-[50%] focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

              <button
                type="button"
                onClick={() => handleRemove(key)}
                className="text-red-600 hover:text-red-800 text-lg"
              >
                ❌
              </button>
            </div>
          ))}
        </div>
      )}
      {/* CATEGORY */}
      {/* <div className="border-t pt-5">
        <h3 className="text-lg font-semibold mb-3">Categories</h3>

        <AddMultiList
          section={{
            title: "Category",

            list: categories,

            setList: setCategories,

            data: STATIC_CATEGORIES,
          }}
          handleAddItem={handleAddItem}
          handleRemoveItem={handleRemoveItem}
        />
      </div> */}
      {/* SUB CATEGORY */}
      {/* <div className="border-t pt-5">
        <h3 className="text-lg font-semibold mb-3">Sub Categories</h3>

        <AddMultiList
          section={{
            title: "Sub Category",

            list: subCategories,

            setList: setSubCategories,

            data: STATIC_SUB_CATEGORIES,
          }}
          handleAddItem={handleAddItem}
          handleRemoveItem={handleRemoveItem}
        />
      </div> */}
      {/* BRAND */}
      {/* <div className="border-t pt-5">
        <h3 className="text-lg font-semibold mb-3">Brands</h3>

        <AddMultiList
          section={{
            title: "Brand",

            list: brands,

            setList: setBrands,

            data: STATIC_BRANDS,
          }}
          handleAddItem={handleAddItem}
          handleRemoveItem={handleRemoveItem}
        />
      </div> */}
      {/* SUBMIT */}
      <div className="flex justify-center pt-5">
        <button
          type="button"
          onClick={handleSubmit}
          disabled={isLoading}
          className={`h-11 px-8 text-white rounded-lg shadow-md transition ${
            isLoading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-green-600 hover:bg-green-700"
          }`}
        >
          {isLoading ? "Saving..." : isEdit ? "Update" : "Submit"}
        </button>
      </div>
    </div>
  );
}

// MULTI SELECT COMPONENT

function AddMultiList({ section, handleAddItem, handleRemoveItem }) {
  const [newItem, setNewItem] = useState({
    title: "",
    id: "",
  });

  // SELECT

  const handleSelect = (e) => {
    const selectedId = e.target.value;

    const selectedItem = section.data.find(
      (item) => String(item.id) === String(selectedId),
    );

    setNewItem({
      id: selectedId,

      title: selectedItem?.title || "",
    });
  };

  // ADD

  const handleAdd = () => {
    if (!newItem.id) {
      toast.warning(`Please select ${section.title}`);

      return;
    }

    const alreadyExists = section.list.some(
      (item) => String(item.id) === String(newItem.id),
    );

    if (alreadyExists) {
      toast.warning(`${section.title} already added`);

      return;
    }

    handleAddItem(section.setList, section.list, newItem);

    setNewItem({
      title: "",
      id: "",
    });
  };

  // UI

  return (
    <div className="space-y-3">
      {/* SELECT */}

      <div className="flex gap-3">
        <select
          value={newItem.id}
          onChange={handleSelect}
          className="border border-gray-300 px-3 py-2 rounded-lg flex-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select {section.title}</option>

          {section.data.map((item) => (
            <option key={item.id} value={item.id}>
              {item.title}
            </option>
          ))}
        </select>

        <button
          type="button"
          onClick={handleAdd}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 rounded-lg"
        >
          Add
        </button>
      </div>

      {/* SELECTED ITEMS */}

      {section.list.length > 0 && (
        <ul className="space-y-2">
          {section.list.map((item, index) => {
            const staticItem = section.data.find(
              (elem) => String(elem.id) === String(item.id),
            );

            return (
              <li
                key={`${item.id}-${index}`}
                className="flex justify-between items-center bg-gray-100 px-4 py-3 rounded-lg"
              >
                <span className="text-gray-700">
                  <strong>{section.title}:</strong>{" "}
                  {staticItem?.title || item.title}
                </span>

                <button
                  type="button"
                  onClick={() =>
                    handleRemoveItem(section.setList, section.list, index)
                  }
                  className="text-red-600 hover:text-red-800 text-lg"
                >
                  ❌
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
